




















































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { ActionNames } from '@/constants/ActionNames';

@Component({
  components: {
    Loading
  }
})
export default class ResetPassword extends Vue {
  public email: string = '';

  public securityCode: number = 123456;

  public newPassword: string = '';

  public newPasswordRepeat: string = '';

  public loading: boolean = false;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public async doPasswordReset() {
    this.loading = true;

    if (this.newPassword !== this.newPasswordRepeat) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'De wachtwoorden komen niet overeen',
      };

      this.loading = false;

      return;
    }

    if (!this.email || !this.securityCode || !this.newPassword || !this.newPasswordRepeat) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Vul een email in',
      }
    } else {
      const success = await this.$store.dispatch(ActionNames.RESET_PASSWORD, {
        email: this.email,
        newPassword: this.newPassword,
        newPasswordRepeat: this.newPasswordRepeat,
        securityCode: this.securityCode,
      });

      if (success) {
        this.error = {
          show: true,
          type: 'success',
          message: 'Je wachtwoord is hersteld! U kunt nu inloggen met uw nieuwe wachtwoord',
        }
      } else {
        this.error = {
          show: true,
          type: 'warning',
          message: 'De beveiligingscode is niet meer geldig of klopt niet',
        }
      }
    }

    this.loading = false;
  }
}
